import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RespuestaModel } from '../../models/respuesta.model';
import { HeadersEnum } from '../../enum/headers.enum';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MainService {

  gatewayNotificacion = environment.gatewayNotificacion;
  gatewayJasper = environment.gatewayJasper;
  gatewaySiarURL = environment.gatewaySiarURL;
  gatewayConfiguracionGlobalURL = environment.gatewayConfiguracionGlobalURL;
  gatewayOficialiaPartesURL = environment.gatewayOficialiaPartesURL;
  gatewayAutenticacionURL = environment.gatewayAutenticacionURL;

  constructor(public httpClient: HttpClient) { }

  getAccessToken(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    const sysId = environment.systemId || 1;
    const envName = (environment.environment || 'Desarrollo').trim().toLowerCase();
    return (
      localStorage.getItem(`accessToken_${sysId}_${envName}`) ||
      localStorage.getItem('accessToken') ||
      null
    );
  }

  getAuthHeaders(extraHeaders?: { [header: string]: string }): HttpHeaders {
    const headersConfig: { [header: string]: string } = {};

    if (typeof localStorage !== 'undefined') {
      const usuario = localStorage.getItem(HeadersEnum.USUARIO);
      const accion = localStorage.getItem(HeadersEnum.ACCION);
      if (usuario !== null) {
        headersConfig['user'] = usuario;
        headersConfig['accion'] = accion === null ? '' : accion;
      }
    }

    const token = this.getAccessToken();
    if (token) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }

    if (extraHeaders) {
      Object.keys(extraHeaders).forEach(key => {
        headersConfig[key] = extraHeaders[key];
      });
    }

    return new HttpHeaders(headersConfig);
  }

  getAsync(url: string): Promise<any> {

    return new Promise(resolve => {
      const subscription = this.httpClient.get<any>(url, { headers: this.getAuthHeaders() })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data);

          }, error => {

            subscription.unsubscribe();

            resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: error.error ? error.error.text : null
            } as RespuestaModel);
          });
    });
  }

  postAsync(url: string, objeto: any): Promise<any> {

    return new Promise(resolve => {

      const subscription = this.httpClient.post(url, objeto, { headers: this.getAuthHeaders() })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { exito: true } as RespuestaModel);
          },
          error => {

            subscription.unsubscribe();

            return resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: null
            } as RespuestaModel);
          });
    });
  }

  postHeaderAsync(url: string, objeto: any, headerValue: string): Promise<any> {

    return new Promise(resolve => {

      const encabezado = this.getAuthHeaders({ user: headerValue });
      const subscription = this.httpClient.post(url, objeto, { headers: encabezado })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { exito: true } as RespuestaModel);
          },
          error => {

            subscription.unsubscribe();

            return resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: null
            } as RespuestaModel);
          });
    });
  }

  putAsync(url: string, objeto: any): Promise<any> {

    return new Promise(resolve => {

      const subscription = this.httpClient.put(url, objeto, { headers: this.getAuthHeaders() })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { exito: true } as RespuestaModel);
          },
          error => {

            subscription.unsubscribe();

            return resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: null
            } as RespuestaModel);
          });
    });
  }

  deleteAsync(url: string): Promise<any> {

    return new Promise(resolve => {

      const subscription = this.httpClient.delete<any>(url, { headers: this.getAuthHeaders() })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data ? data : { exito: true } as RespuestaModel);

          }, error => {

            subscription.unsubscribe();

            resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: null
            } as RespuestaModel);
          });
    });
  }

  descargarArchivoAsync(url: string, defaultFilename?: string): Promise<void> {
    return new Promise(resolve => {
      const subscription = this.httpClient.get(url, {
        headers: this.getAuthHeaders(),
        responseType: 'blob'
      }).subscribe(
        (blob: Blob) => {
          subscription.unsubscribe();
          const objectUrl = window.URL.createObjectURL(blob);
          if (!defaultFilename && blob.type && blob.type.includes('pdf')) {
            window.open(objectUrl, '_blank');
          } else {
            const downloadLink = document.createElement('a');
            downloadLink.href = objectUrl;
            downloadLink.download = defaultFilename || 'documento';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.parentNode.removeChild(downloadLink);
          }
          resolve();
        },
        error => {
          subscription.unsubscribe();
          console.error('Error al descargar archivo:', error);
          resolve();
        }
      );
    });
  }


  get() {
    return new Promise(resolve => {
      const subscription = this.httpClient.get('../../../../assets/datos/plantilla.json', { responseType: 'text' })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data);

          }, error => {

            subscription.unsubscribe();

            resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: error.error ? error.error.text : null
            } as RespuestaModel);
          });
    });
  }

  obtenerUsuariosCSV_() {
    return new Promise(resolve => {
      const subscription = this.httpClient.get('../../../../assets/datos/usuarios.json', { responseType: 'text' })
        .subscribe(
          data => {

            subscription.unsubscribe();

            resolve(data);

          }, error => {

            subscription.unsubscribe();

            resolve({
              exito: false,
              mensaje: error.message.toString(),
              respuesta: error.error ? error.error.text : null
            } as RespuestaModel);
          });
    });
  }

}
